import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http'
import { FormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CounterComponent } from './counter/counter.component';
import { FetchDataComponent } from './fetch-data/fetch-data.component';
import { NavbarComponent } from './navbar/navbar.component';
import { FunctionCallerPipe, HomeComponent } from './home/home.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { AnnoncesComponent } from './annonces/annonces.component';
import { FooterComponent, DialogOverviewProbDialog } from './footer/footer.component';
import { MapsComponent } from './maps/maps.component';
import { MomentDateAdapter } from '@angular/material-moment-adapter';

import { JwSocialButtonsModule } from 'jw-angular-social-buttons';

import {
  AgmCoreModule
} from '@agm/core';
import { AnnonceReadComponent } from './annonce-read/annonce-read.component';
import { ReponseComponent } from './reponse/reponse.component';
import { MatDialogModule, MAT_DIALOG_DATA, MAT_DIALOG_DEFAULT_OPTIONS, MatDialogRef} from '@angular/material/dialog';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

import { MatTableModule } from '@angular/material/table';

import { MatButtonModule } from '@angular/material/button';
import { MatPaginatorModule, MatPaginatorIntl } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatCardModule } from '@angular/material/card';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTabsModule } from '@angular/material/tabs';
import { MatDividerModule } from '@angular/material/divider';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatStepperModule } from '@angular/material/stepper';
import {MatMenuModule} from '@angular/material/menu';
import { ReactiveFormsModule } from '@angular/forms';

import { AfterIfDirective, InscriptionComponent } from './inscription/inscription.component';
import {AuthService} from "./services/auth.service";
import {AuthComponent} from "./auth/auth.component";
import {RouterModule, Routes} from "@angular/router";
import {MenuComponent} from "./menu/menu.component";
import {ProfilComponent} from "./profil/profil.component";
import {EditPasswordComponent} from "./edit-password/edit-password.component";
import {DialogConsentement, EditInfosComponent, MY_FORMATS} from "./edit-infos/edit-infos.component";
import {MatIconModule} from "@angular/material/icon";
import {MatButtonToggleModule} from "@angular/material/button-toggle";
import {JobalertComponent, ReplaceLineBreaks} from "./jobalert/jobalert.component";
import {ConfirmComponent} from "./confirm/confirm.component";
import {ConfirmService} from "./services/confirm.service";
import {AddEditFormComponent} from "./add-edit-form/add-edit-form.component";
import {EditJobalertComponent} from "./edit-jobalert/edit-jobalert.component";
import {UpdateDatatableService} from "./services/update-datatable-service";
import {PieceJointeComponent} from "./piece-jointe/piece-jointe.component";
import {EncryptDecryptService} from "./services/encrypt-decrypt.service";
import {MatPasswordStrengthModule} from "@angular-material-extensions/password-strength";
import {MatSlideToggleModule} from "@angular/material/slide-toggle";
import {NgxDocViewerModule} from "ngx-doc-viewer";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatNativeDateModule} from "@angular/material/core";
import {MatRadioModule} from "@angular/material/radio";
import { MatChipsModule } from "@angular/material/chips";
import { MatAutocompleteModule } from '@angular/material/autocomplete';

import { HereMapComponent } from './here-map/here-map.component';
import { MatBadgeModule } from "@angular/material/badge";
import {AddExperienceComponent} from "./add-experience/add-experience.component";
import {EditExperienceComponent} from "./edit-experience/edit-experience.component";
import { LostPasswordComponent } from './lost-password/lost-password.component';
import { BackProfilComponent } from './back-profil/back-profil.component';
import { MenuProfilComponent } from './menu-profil/menu-profil.component';

import { VariablesGlobales  } from './services/globals';
import { AddJobalertComponent } from './add-jobalert/add-jobalert.component';
import { ReponseHistoriqueComponent } from './reponse-historique/reponse-historique.component';
import { EditReponsePjComponent } from './edit-reponse-pj/edit-reponse-pj.component';
import { DialogPjComponent } from './dialog-pj/dialog-pj.component'
import { getFrenchPaginatorIntl } from './services/french-paginator-intl';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { TopAnnonceComponent } from './top-annonce/top-annonce.component';

import { MatCarouselModule } from '@ngmodule/material-carousel';
import { AboutComponent } from './about/about.component';

import { DialogOverviewExampleDialog } from './annonce-read/annonce-read.component';
import { JwtModule, JwtModuleOptions } from '@auth0/angular-jwt';

import { DataTablesModule } from "angular-datatables";
import { DatePipe } from '@angular/common';
import { StatusComponent } from './status/status.component';

import { NgSpcModule } from 'ng-spc';
import { TopannonceBisComponent } from './topannonce-bis/topannonce-bis.component';
import { HoverclassDirective } from './hoverclass.directive'
import { MatchHeightDirective, MatchHeightModule } from './directives/match-height.directive';
import { ConfigService } from './services/config.service';
import { EditInfosKarmaComponent } from './edit-infos-karma/edit-infos-karma.component';

const appRoutes: Routes = [
    {path: 'auth', component: AuthComponent}
  ]

const dialogMock = {
  close: () => { }
};


@NgModule({
    declarations: [
        AppComponent,
    CounterComponent,
    FunctionCallerPipe,
        FetchDataComponent,
        NavbarComponent,
        HomeComponent,
        SidebarComponent,
        AnnoncesComponent,
        FooterComponent,
        MapsComponent,
        AnnonceReadComponent,
        ReponseComponent,
        InscriptionComponent,
        MenuComponent,
        ProfilComponent,
        EditPasswordComponent,
        EditInfosComponent,
        AuthComponent,
        ConfirmComponent,
        AddEditFormComponent,
        EditJobalertComponent,
        AddExperienceComponent,
        EditExperienceComponent,
        JobalertComponent,
        PieceJointeComponent,
        HereMapComponent,
        LostPasswordComponent,
        BackProfilComponent,
        MenuProfilComponent,
        AddJobalertComponent,
        ReplaceLineBreaks,
        ReponseHistoriqueComponent,
        EditReponsePjComponent,
        DialogPjComponent,
        TopAnnonceComponent,
        AboutComponent,
        DialogOverviewExampleDialog,
        DialogOverviewProbDialog,
        StatusComponent,
        AfterIfDirective,
        DialogConsentement,
        TopannonceBisComponent,
        HoverclassDirective,
        EditInfosKarmaComponent
    ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyCt-rqJqpoh23hihNTcE9987TZqj8gLnL4'
    }),
    MatDialogModule,
    FormsModule,
    NgxDocViewerModule,
    MatFormFieldModule,
    MatInputModule,
    MatTableModule,
    MatButtonModule,
    MatBadgeModule,
    MatPaginatorModule,
    MatSelectModule,
    MatSortModule,
    MatTooltipModule,
    MatCardModule,
    MatProgressBarModule,
    MatExpansionModule,
    MatMenuModule,
    MatIconModule,
    MatTabsModule,
    MatDividerModule,
    MatSnackBarModule,
    MatDatepickerModule,
    MatStepperModule,
    RouterModule.forRoot(appRoutes),
    ReactiveFormsModule,
    MatPasswordStrengthModule,
    MatSlideToggleModule,
    MatNativeDateModule,
    MatChipsModule,
    MatRadioModule,
    MatButtonToggleModule,
    MatAutocompleteModule,
    MatBottomSheetModule,
    ScrollingModule,
    MatCheckboxModule,
    MatCarouselModule.forRoot(),
    JwSocialButtonsModule,
    DataTablesModule,
    NgSpcModule,
    MatchHeightModule
  ],

  entryComponents: [
    EditJobalertComponent,
    DialogOverviewExampleDialog,
    AddJobalertComponent,
    ConfirmComponent,
    EditReponsePjComponent,
    InscriptionComponent,
    DialogPjComponent,
    AddExperienceComponent,
    DialogOverviewProbDialog,
    EditExperienceComponent,
    DialogConsentement
  ],
  providers: [
    { provide: 'BASE_URL', useFactory: getBaseUrl },
    { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { hasBackdrop: true } },
    { provide: MAT_DIALOG_DATA, useValue: {} },
    {provide: MAT_DATE_LOCALE, useValue: 'fr-FR' },
    {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
    AuthService,
    EncryptDecryptService,
    UpdateDatatableService,
    ConfirmService,
    DatePipe,
    VariablesGlobales,
    ConfigService,
    { provide: MatPaginatorIntl, useValue: getFrenchPaginatorIntl() },
    { provide: MatDialogRef, useValue: dialogMock },

  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

export function getBaseUrl() {
  return document.getElementsByTagName('base')[0].href;
}
